import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import { EmployeesPage } from './EmployeesPage';
import { EmployeeFormPage } from './EmployeeFormPage';
import { EmployeeDetailPage } from './EmployeeDetailPage';
import { StructurePage } from './StructurePage';
import type { BackofficeModule } from '../registry';

/** Bausteine für andere Seiten: „Mein Konto“ (KON-119) und die Freistellung in der Anfrage (KON-121) */
export { LeaveRequestForm, MyEmployeeProfile, MyFiles, MyLeaveRequests, MyVacation, useMyEmployee } from './MyEmployeePages';
export { InquiryLeavePanel } from './InquiryLeavePanel';

/**
 * Einstiegspunkt des Moduls „Mitarbeiter“ im Backoffice. Alles dazu liegt in diesem Ordner. Das Backoffice kennt nur diese Datei
 * (siehe registry.tsx). Die Verträge zur API stehen in packages/shared/src/hr.
 */
export const hrModule: BackofficeModule = {
  key: 'hr',
  path: '/mitarbeiter',
  // Abteilungen & Positionen pflegt der Mandant in der Einrichtung (Gruppe „Personalmanagement“). Der Bereich gehört zum Modul „setup“, sonst verschwände das Modul aus der Seitenleiste.
  setupSections: [
    {
      path: 'abteilungen-positionen',
      label: 'Abteilungen & Positionen',
      module: 'setup',
      permission: 'hr.read',
      requires: 'hr',
      description: 'Die Struktur Ihres Unternehmens: Abteilungen und Positionen. Die Positionen sind die Auswahl beim Anlegen von Mitarbeitern und in der Schichtplanung.',
      built: true,
      group: 'team',
      keywords: ['Abteilung', 'Position', 'Struktur', 'Organigramm', 'Stelle', 'Mitarbeiter', 'Schicht'],
    },
  ],
  setupRoutes: <Route path="abteilungen-positionen" element={<ModuleGate module="hr" permission="hr.read"><StructurePage /></ModuleGate>} />,
  routes: (
    <>
      <Route path="mitarbeiter" element={<ModuleGate module="hr" permission="hr.read"><EmployeesPage /></ModuleGate>} />
      <Route path="mitarbeiter/neu" element={<ModuleGate module="hr" permission="hr.write"><EmployeeFormPage /></ModuleGate>} />
      <Route path="mitarbeiter/:id" element={<ModuleGate module="hr" permission="hr.read"><EmployeeDetailPage /></ModuleGate>} />
      <Route path="mitarbeiter/:id/bearbeiten" element={<ModuleGate module="hr" permission="hr.write"><EmployeeFormPage /></ModuleGate>} />
    </>
  ),
};
